var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 22 14","fill":"none"}},[_c('path',{staticClass:"icon",attrs:{"d":"M15.1367 0.426163L17.5894 2.87885L12.3627 8.10553L8.07851 3.82136L0.14209 11.7685L1.65226 13.2787L8.07851 6.85241L12.3627 11.1366L19.1102 4.39973L21.5629 6.85241V0.426163H15.1367Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }